import "./dateChooser.scss";
import CustomDatePicker from "../customDatePicker/customDatePicker";

export default function DateChooser({label, date, setDate, minDate = null, maxDate = null, inputWidth}) {

  return (
    <div className="dateChooser">
      <label>{label}</label>
      <CustomDatePicker date={date} setDate={setDate} minDate={minDate} maxDate={maxDate} inputWidth={inputWidth} />
    </div>
  );
}
